const GA_MEASUREMENT_ID = 'G-88H80YLK5D';

let loaded = false;
const readyListeners = new Set();

export function normalizeConsent(consent = {}) {
  const ads = consent.ad_storage === 'granted' ? 'granted' : 'denied';
  const granted = (value, fallback) => (value == null ? fallback : value === 'granted' ? 'granted' : 'denied');

  return {
    analytics_storage: consent.analytics_storage === 'granted' ? 'granted' : 'denied',
    ad_storage: ads,
    ad_user_data: granted(consent.ad_user_data, ads),
    ad_personalization: granted(consent.ad_personalization, ads),
  };
}

export function loadAnalytics() {
  if (loaded || typeof document === 'undefined') return;
  loaded = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  readyListeners.forEach((listener) => listener());
  readyListeners.clear();
}

export function onAnalyticsReady(listener) {
  if (loaded) {
    listener();
    return () => {};
  }
  readyListeners.add(listener);
  return () => readyListeners.delete(listener);
}

export function trackPageView() {
  if (!loaded || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: `${window.location.pathname}${window.location.search}`,
  });
}

export function shouldLoadAnalytics(consent) {
  return consent?.analytics_storage === 'granted';
}
